var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('list-layout',{attrs:{"title":_vm.title}},[_c('app-table-design',{attrs:{"items":_vm.items,"headers":_vm.getHeaders,"loading":_vm.isLoading,"total-element-data-table":_vm.total}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }